import Button from '@/components/Button'
import Modal from '@/widgets/Modal'
import * as styles from './style'

interface Props {
  handleDialogOpen: () => void
}

const InfoModal = ({ handleDialogOpen }: Props): JSX.Element => {
  return (
    <Modal className="p-0" onDismiss={handleDialogOpen}>
      <div className={styles.videoContainer}>
        <div>
          <video data-testid="video" className={styles.video} controls>
            <source src={'https://ddq2bomue87t4.cloudfront.net/videos/helen-capabilities.mp4'} type="video/mp4" />
          </video>
        </div>
      </div>
      <div className={styles.infoBlock}>
        <p className={styles.info}>
          As a Digital Assistant, I can help you personalize meal plans, give you fitness plans, help answer your
          questions on technology, Government programs etc.
        </p>
      </div>
      <Button label="Close" onClick={handleDialogOpen} component="button" className="w-full mb-5" />
    </Modal>
  )
}

export default InfoModal
